export const colorConstants = [
   { $blue_600        : "#337CBD"},
   { $green_600       : "#2A8E6D"},
   { $light_green_600 : "#8BBD2D"},
   { $purple_500      : "#6358C7"},
   { $teal_500        : "#00B8D4"},
   { $red_500         : "#F24336"},
   { $yellow_500      : "#FDB611"},
];